<div class="correctors-widget">
    <ul class="list-unstyled" [ngStyle]="{ 'max-height': widgetMaxHeight+'px' }">
        <li *ngFor="let item of correctors" class="p-2" style="background: gray; border-radius: 4px;">
            <p  class="fw-bold">{{item.Name}}</p>
            <div class="d-flex align-items-center">
                <dx-button
                    icon="minus"
                    style="color: #363640;"
                    stylingMode="contained"
                    [disabled]="!(supplierState | async) || !(isEnabledByFenixRole() | async)"
                    (onClick)="decrement(item)"
                    >
                </dx-button>
                <p class="mx-2 mb-0 fw-bold">{{item.ApplyNTimes}}</p>
                <dx-button
                    icon="plus"
                    stylingMode="contained"
                    style="color: #363640;"
                    class="mr-2"
                    [disabled]="!(supplierState | async) || !(isEnabledByFenixRole() | async)"
                    (onClick)="increment(item)"
                    >
                </dx-button>
                <ng-container *ngIf="item.GroupEnable != undefined">
                    <dx-button
                        *ngIf="item.GroupEnable === true"
                        [text]="'ON'"
                        [disabled]="!(supplierState | async) || !(isEnabledByFenixRole() | async)"
                        (onClick)="toggle(item)"
                    ></dx-button>
                    <dx-button
                        *ngIf="item.GroupEnable === false"
                        [text]="'OFF'"
                        [disabled]="!(supplierState | async) || !(isEnabledByFenixRole() | async)"
                        (onClick)="toggle(item)"
                    ></dx-button>
                </ng-container>
            </div>
        </li>
    </ul>
</div>
